import { motion } from "framer-motion";
import { FileCheck, Eye, HelpCircle } from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../../lib/motion";
import { TRUST_STATES } from "../../lib/product";
import { SectionIntro, STATUS_TONES } from "./shared";

const ICONS = { FileCheck, Eye, HelpCircle };

const TrustSystem = () => (
    <section
        id="trust"
        data-testid="trust-system-section"
        className="relative bg-ink py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <SectionIntro
                testid="trust-intro"
                align="center"
                eyebrow="THE TRUST SYSTEM"
                title="Know what BuildEase knows."
            />

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-14 grid gap-6 md:grid-cols-3"
            >
                {TRUST_STATES.map((state) => {
                    const tone = STATUS_TONES[state.tone];
                    const Icon = ICONS[state.icon];
                    return (
                        <motion.div
                            key={state.id}
                            variants={fadeUp}
                            data-testid={`trust-state-${state.id}`}
                            className="border border-white/12 bg-[#0C1428] px-7 py-8"
                        >
                            <span
                                className={`flex h-12 w-12 items-center justify-center border ${tone.border} ${tone.text}`}
                            >
                                <Icon
                                    className="h-5 w-5"
                                    strokeWidth={1.5}
                                    aria-hidden="true"
                                />
                            </span>
                            <p
                                className={`mt-6 flex items-center gap-2.5 font-mono text-[13px] tracking-[0.3em] ${tone.text}`}
                            >
                                <span
                                    className={`h-1.5 w-1.5 rounded-full ${tone.dot}`}
                                />
                                {state.label}
                            </p>
                            <p className="mt-4 text-[15px] leading-relaxed text-mist">
                                {state.copy}
                            </p>
                        </motion.div>
                    );
                })}
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mx-auto mt-16 max-w-3xl text-center"
            >
                <span
                    aria-hidden="true"
                    className="mx-auto block h-px w-16 bg-accent"
                />
                <p
                    data-testid="trust-statement"
                    className="mt-8 font-display text-2xl font-semibold leading-snug tracking-tight text-white md:text-4xl"
                >
                    BuildEase never presents an assumption as a verified
                    architectural fact.
                </p>
                <p className="mt-6 font-mono text-[13px] tracking-[0.3em] text-cad">
                    AI INTERPRETS · DETERMINISTIC SYSTEMS CALCULATE · VERIFIED
                    DATA ESTABLISHES FACTS
                </p>
            </motion.div>
        </div>
    </section>
);

export default TrustSystem;
